import React, { useEffect, useRef, useState } from 'react';
import { Icon } from 'assets/Icon';
import './About.scss';

const About: React.FC = () => {
  const [isVisible, setIsVisible] = useState<boolean>(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      { threshold: 0.2 }
    );

    const currentRef = sectionRef.current;
    if (currentRef) {
      observer.observe(currentRef);
    }

    return () => {
      if (currentRef) {
        observer.unobserve(currentRef);
      }
    };
  }, []);

  return (
    <section className="about-section">
      <div className={`about-content ${isVisible ? 'visible' : ''}`} ref={sectionRef}>
        <div className="about-header">
          <h2>Who We Are</h2>
          <a 
            href="https://www.sgtlaw.com/" 
            className="about-link" 
            target="_blank" 
            rel="noopener noreferrer"
          >
            SGT LAW
            <Icon name="arrow" />
          </a>
        </div>
        <div className="about-columns">
          <div className="about-column">
            <p>
              Silver Golub &amp; Teitell LLP ("SGT") is a boutique Connecticut law firm dedicated to 
              plaintiffs' litigation. Since 1978, we've pursued life-changing cases both in Connecticut 
              and nationwide. We take only significant cases, and we're unafraid to invest the resources, 
              time, and expertise that others can't or won't.
            </p>
          </div>
          <div className="about-column">
            <p>
              SGT pioneered resource-intensive medical-malpractice and personal-injury litigation, 
              earning us recognition throughout Connecticut. That's why nearly all our medical-malpractice 
              and personal-injury clients are referred by judges, former clients, and other lawyers 
              familiar with our work.
            </p>
          </div>
          <div className="about-column">
            <p>
              Our class action and complex litigation practices represent individuals, businesses, 
              institutional investors, family offices, and government entities in all types of 
              class-action and complex litigation at both trial and appellate levels. We frequently 
              file cutting-edge cases on emerging issues nationwide, achieving landmark results and 
              recovering billions for our clients. Because of our success and national reputation, 
              SGT is often appointed lead counsel in high-value class actions where real people have 
              suffered avoidable, life-altering consequences.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;

